import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Avatar from '@mui/material/Avatar';

export default function HeaderBack({titleHead,avatar}) {
	let navigate = useNavigate();
	  
	  const handleLogOut = () => {
		sessionStorage.removeItem("Auth Token");
		navigate('/');
		}
	
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
		  <ArrowBackIcon onClick={() => {navigate(-1)}} sx={{mr: 2}}/> 
		{avatar && (
					<div className="post-user-info">
						<Avatar alt="Remy Sharp" src="https://source.unsplash.com/random/girl" onClick={() => {navigate('/profile')}} sx={{ width: 35, height: 35 }} />
						<div className="post-user-id">
							<h3>Infi</h3>
							<h5>@infi</h5>
						</div>
					</div>
		)}
		  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {titleHead}
          </Typography>
          <Button variant="outlined" color="inherit" onClick={handleLogOut}>Logout</Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
